import {Button, Card} from 'platform/components';
import {Box, Grid, Heading, HStack, Show, Text, VStack} from 'platform/foundation';
import {DateTimeFormat} from 'platform/locale';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

import {MY_DAY_PREVIEW_DATA} from '../../constants/MY_DAY_PREVIEW_DATA';
import {MyDayOrb} from '../MyDayOrb/MyDayOrb';
import {RecommendationRowView} from '../RecommendationRowView/RecommendationRowView';

interface RecommendedActionsPreviewProps {
  limit: 3 | 4 | 8;
  isWide?: boolean;
  onViewAll?: () => void;
}

export function RecommendedActionsPreview(props: RecommendedActionsPreviewProps) {
  const recommendations = MY_DAY_PREVIEW_DATA.recommendations.slice(0, props.limit);
  const remainingCount = MY_DAY_PREVIEW_DATA.recommendations.length - recommendations.length;

  return (
    <Card isFullHeight>
      <VStack spacing={3} height="100%" minHeight={0}>
        <HStack spacing={3} align="center" justify="space-between" wrap>
          <HStack spacing={3} align="center">
            <MyDayOrb />
            <VStack spacing={1}>
              <Text size="xSmall" color="secondary">
                {i18n.t('aiAssistant.interest.digest.title')}
              </Text>
              <Heading size={4} headingLevel={2}>
                {i18n.t('page.interestMyDay.recommendations.title')}
              </Heading>
            </VStack>
          </HStack>
          <Show when={props.onViewAll}>
            {(onViewAll) => (
              <Button
                variant="link"
                title={i18n.t('general.actions.viewAll')}
                rightIcon="navigation/chevron_right"
                onClick={onViewAll}
              />
            )}
          </Show>
        </HStack>
        <Text size="xSmall" color="secondary">
          {i18n.t('general.labels.lastUpdated')}{' '}
          <DateTimeFormat
            value={parseDate(MY_DAY_PREVIEW_DATA.evaluatedAt)}
            format="dateTimeMedium"
          />
        </Text>
        <Box role="list" tabIndex={0} overflowY="auto" minHeight={0} flex={1}>
          <Grid columns={props.isWide ? [1, 1, 3, 3] : 1} spacing={2}>
            {recommendations.map((recommendation, index) => (
              <Box role="listitem" key={recommendation.interestId}>
                <RecommendationRowView
                  recommendation={recommendation}
                  position={index + 1}
                  vehicleLabel={
                    MY_DAY_PREVIEW_DATA.contextByInterestId?.[recommendation.interestId]
                      ?.vehicleLabel
                  }
                />
              </Box>
            ))}
          </Grid>
        </Box>
        <Show when={remainingCount > 0}>
          <Text size="small" color="secondary">
            {i18n.t('entity.sourcing.labels.nMore', {count: remainingCount})}
          </Text>
        </Show>
      </VStack>
    </Card>
  );
}
